document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('ctaButton');
  const main = document.querySelector('main');

  if (button) {
    window.addEventListener('scroll', () => {
      const mainBottom = main.getBoundingClientRect().bottom;
      const windowHeight = window.innerHeight;

      if (mainBottom <= windowHeight) {
        button.classList.add('is-stopped');
      } else {
        button.classList.remove('is-stopped');
      }
    });
  }
});
